/* ============================================================
   GABBIANO CUSTOM — Model view toggle (feature 8)
   ------------------------------------------------------------
   Adds a "Model view" switch to the collection / search toolbar
   (.collection__toolbar). On = html.gb-model-view, which makes
   product cards show the model photo (2nd image) by default and
   the packshot (1st image) on hover. All visuals live in
   product-card-model-view.css.

   The choice is remembered in localStorage ('gb-model-view'),
   and an inline script in layout/theme.liquid applies it in
   <head> before first paint, so there is no flash.

   No core snippet is edited: the switch is inserted by this
   script and re-inserted when the theme re-renders the toolbar
   after filtering or sorting.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'gb-model-view';
  var CLASS_NAME = 'gb-model-view';
  var LABEL = 'Model view';
  var root = document.documentElement;

  function isOn() {
    return root.classList.contains(CLASS_NAME);
  }

  function sync() {
    var on = isOn();
    document.querySelectorAll('.gb-model-toggle').forEach(function (button) {
      button.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  function setOn(on) {
    root.classList.toggle(CLASS_NAME, on);
    try { localStorage.setItem(KEY, on ? '1' : '0'); } catch (e) { /* private mode: works for this page only */ }
    sync();
  }

  function build() {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'gb-model-toggle subheading';
    button.setAttribute('role', 'switch');
    button.setAttribute('aria-checked', isOn() ? 'true' : 'false');
    button.innerHTML =
      '<span class="gb-model-toggle__label">' + LABEL + '</span>' +
      '<span class="gb-model-toggle__track" aria-hidden="true"><span class="gb-model-toggle__thumb"></span></span>';

    button.addEventListener('click', function () {
      setOn(!isOn());
    });

    return button;
  }

  function inject() {
    document.querySelectorAll('.collection__toolbar').forEach(function (toolbar) {
      if (toolbar.querySelector('.gb-model-toggle')) return;

      var list = toolbar.querySelector('.vertically-separated-list');
      var button = build();

      if (list) {
        list.insertBefore(button, list.firstChild);
      } else {
        toolbar.appendChild(button);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }

  /* The theme swaps the collection markup after filter / sort changes */
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      inject();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
